import _Reflect$ownKeys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/reflect/own-keys";
import "core-js/modules/web.dom.iterable";
import _objectSpread from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread";
import _toConsumableArray from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _Array$isArray from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/array/is-array";
import _WeakMap from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/weak-map";
import _typeof from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
export var isObject = function isObject(obj) {
  return _typeof(obj) === 'object' && obj !== null;
};
export var deepClone = function deepClone(source) {
  var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _WeakMap();

  // 如果不是对象，则直接返回
  if (!isObject(source)) {
    return source;
  } // 如果hash表中存在，获取hash表中存储过的值


  if (hash.has(source)) {
    return hash.get(source);
  } // 过滤数组还是对象


  var target = _Array$isArray(source) ? _toConsumableArray(source) : _objectSpread({}, source);
  hash.set(source, target); // reflect.ownKeys方法取出包含symbol类型的所有的key

  _Reflect$ownKeys(target).forEach(function (key) {
    if (isObject(source[key])) {
      target[key] = deepClone(source[key], hash);
    } else {
      target[key] = source[key];
    }
  });

  return target;
};